export default __webpack_public_path__ + "static/media/attentionCircle.86ee86d9.svg";